var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useTranslation } from "../../next-i18next";
import { FieldInput } from "./FieldInput/FieldInput";
export var FormattedFieldWrapper = function (_a) {
    var field = _a.field, props = __rest(_a, ["field"]);
    var t = useTranslation().t;
    var processInput = function (_, value) {
        var formattedValue = t(props.formatterName, {
            val: value,
            interpolation: { escapeValue: false },
        });
        props.setFieldValue(props.name, formattedValue);
    };
    return <FieldInput {...field} {...props} processInput={processInput}/>;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRm9ybWF0dGVkRmllbGRXcmFwcGVyLmpzeCIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIkZvcm1hdHRlZEZpZWxkV3JhcHBlci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7QUFBQSxPQUFPLEVBQUUsY0FBYyxFQUFFLE1BQU0sb0JBQW9CLENBQUM7QUFFcEQsT0FBTyxFQUFFLFVBQVUsRUFBRSxNQUFNLHlCQUF5QixDQUFDO0FBRXJELE1BQU0sQ0FBQyxJQUFNLHFCQUFxQixHQUFHLFVBQUMsRUFBbUI7SUFBakIsSUFBQSxLQUFLLFdBQUEsRUFBSyxLQUFLLGNBQWpCLFNBQW1CLENBQUY7SUFDN0MsSUFBQSxDQUFDLEdBQUssY0FBYyxFQUFFLEVBQXJCLENBQXNCO0lBQy9CLElBQU0sWUFBWSxHQUFHLFVBQUMsQ0FBUyxFQUFFLEtBQWE7UUFDNUMsSUFBTSxjQUFjLEdBQUcsQ0FBQyxDQUFDLEtBQUssQ0FBQyxhQUFhLEVBQUU7WUFDNUMsR0FBRyxFQUFFLEtBQUs7WUFDVixhQUFhLEVBQUUsRUFBRSxXQUFXLEVBQUUsS0FBSyxFQUFFO1NBQ3RDLENBQUMsQ0FBQztRQUNILEtBQUssQ0FBQyxhQUFhLENBQUMsS0FBSyxDQUFDLElBQUksRUFBRSxjQUFjLENBQUMsQ0FBQztJQUNsRCxDQUFDLENBQUM7SUFDRixPQUFPLENBQUMsVUFBVSxDQUFDLElBQUksS0FBSyxDQUFDLENBQUMsSUFBSSxLQUFLLENBQUMsQ0FBQyxZQUFZLENBQUMsQ0FBQyxZQUFZLENBQUMsRUFBRyxDQUFDO0FBQzFFLENBQUMsQ0FBQyJ9